<template>
  <div id="user-table" v-if="$auth.check(['Pull'])">
    <div v-if="loading" class="overlay">
      <div><img class="spinner" src="loading.gif" alt="Loading data..." /></div>
    </div>
    <h1 style="text-align: left; text-transform: uppercase">
      Pedidos de resgate
    </h1>
    <div class="">
      <div v-if="!filteredTeam || filteredTeam.length === 0">
        Sem pedidos de resgate
      </div>
      <div v-else>
        <div class="card-content">
          <div
            v-for="(dsr, index) in filteredTeam"
            :key="dsr.id"
            class="card"
            style="
              border: 1px solid #e7d9d0;
              border-radius: 8px;
              padding: 16px;
              margin-bottom: 16px;
              box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            "
          >
            <!-- Nome at the top -->
            <div style="margin-bottom: 16px">
              <div style="font-size: 18px; color: #666">Nome</div>
              <strong style="font-size: 24px; color: #333">{{
                dsr.name
              }}</strong>
            </div>

            <!-- Pontos with values aligned to the right -->
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin-bottom: 8px;
              "
            >
              <div style="font-size: 18px; color: #333">Pontos UFS</div>
              <div style="font-size: 18px; color: #333; text-align: right">
                {{ Math.round(dsr.ufs_points) }}
              </div>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin-bottom: 8px;
              "
            >
              <div style="font-size: 18px; color: #333">Pontos OLA</div>
              <div style="font-size: 18px; color: #333; text-align: right">
                {{ Math.round(dsr.ola_points) }}
              </div>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin-bottom: 16px;
              "
            >
              <div style="font-size: 18px; color: #666">Total</div>
              <div style="font-size: 18px; color: #f48c4f; text-align: right">
                {{ Math.round(dsr.total) }}
              </div>
            </div>

            <!-- "Ver recibo" button -->
            <div style="margin-bottom: 10px">
              <button
                @click="openModal(dsr.image)"
                style="
                  background-color: #f48c4f;
                  font-size: 14px;
                  color: white;
                  border: none;
                  width: 100%;
                  padding: 8px;
                  border-radius: 8px;
                  cursor: pointer;
                  text-transform: uppercase;
                "
              >
                Ver recibo
              </button>
            </div>

            <!-- Reject and Approve buttons -->
            <div
              style="
                display: flex;
                gap: 8px;
                width: 100%;
                justify-content: space-between;
              "
            >
              <button
                :id="'reject-' + index"
                @click="openRejectionModal(dsr.id)"
                style="
                  background-color: #dc3545;
                  color: white;
                  border: none;
                  width: 50%;
                  padding: 12px;
                  border-radius: 8px;
                  cursor: pointer;
                "
              >
                <i class="fa fa-times"></i> Rejeitar
              </button>
              <button
                :id="'approve-' + index"
                @click="() => updatePullRequest(dsr.id, 'A')"
                style="
                  background-color: #28a745;
                  color: white;
                  border: none;
                  width: 50%;
                  padding: 12px;
                  border-radius: 8px;
                  cursor: pointer;
                "
              >
                <i class="fa fa-check"></i> Aprovar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Rejection Modal -->
    <div
      id="rejection-modal"
      class="modal-overlay"
      v-if="isModalOpen"
      @click="closeRejectionModal"
    >
      <div class="modal-content" @click.stop>
        <h3
          style="
            text-transform: uppercase;
            margin-top: 10px;
            margin-bottom: 30px;
          "
        >
          Motivo de Rejeição
        </h3>
        <form @submit.prevent="submitRejection">
          <div class="form-group">
            <textarea
              v-model="message"
              placeholder="Indique o motivo de rejeição"
              class="form-control form-name"
            ></textarea>
          </div>

          <!-- Buttons in the same line, each taking 50% of the space with centered text -->
          <div
            class="form-group"
            style="display: flex; gap: 8px; margin-top: 16px"
          >
            <button
              type="button"
              class="btn btn-secondary format"
              @click="closeRejectionModal"
              style="
                flex: 1;
                border: none;
                padding: 12px;
                text-align: center;
                display: flex;
                justify-content: center;
                align-items: center;
                height: 45px;
              "
            >
              CANCELAR
            </button>

            <button
              type="submit"
              class="btn btn-primary"
              style="
                flex: 1;
                border: none;
                padding: 12px;
                text-align: center;
                display: flex;
                justify-content: center;
                align-items: center;
                height: 45px;
              "
            >
              ENVIAR
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- Image Modal -->
    <div v-if="modalOpen" class="modal modal-overlay" @click.self="closeModal">
      <div class="modal-content">
        <span class="close" @click="closeModal">&times;</span>
        <img
          v-if="!isPdf"
          :src="currentImage"
          alt="Recibo"
          style="max-width: 100%; max-height: 80vh"
        />

        <!-- PDF -->
        <iframe
          v-else
          :src="currentImage"
          style="width: 100%; height: 80vh"
          frameborder="0"
        ></iframe>
      </div>
    </div>
  </div>
  <div v-else>
    <p>Access Denied: You are not authorized to view this page.</p>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      loading: null,
      team: [],
      modalOpen: false,
      currentImage: null,
      action: null,
      isModalOpen: false,
      message: "",
      rejectionId: null,
      currentYear: new Date().getFullYear(),
    };
  },

  computed: {
    filteredTeam() {
      const map = new Map();

      this.team.forEach((dsr) => {
        // Only care about pending ones
        if (dsr.status_id === 0) {
          // One pending per dsr_id
          map.set(dsr.dsr_id, dsr);
        }
      });

      // Convert Map → Array for v-for
      return Array.from(map.values());
    },

    isPdf() {
      if (!this.currentImage) return false;
      return this.currentImage.toLowerCase().endsWith(".pdf");
    },
  },

  async mounted() {
    this.fetchName();
    this.fetchTeam();
  },

  methods: {
    async fetchTeam() {
      this.loading = true;
      this.error = null;

      try {
        const response = await axios.get(`app/getTeamPull`);

        if (response.status === 200 && response.data) {
          this.team = response.data;
        } else {
          console.error("Failed to fetch data:", response);
        }
      } catch (error) {
        console.error("Error fetching team data:", error);
        if (error.response) {
          console.error("Error response:", error.response.data);
        }
      } finally {
        this.loading = false; // Always reset loading
      }
    },

    openRejectionModal(id) {
      this.rejectionId = id; // Store the ID of the request being rejected
      this.isModalOpen = true; // Open the rejection modal
    },
    closeRejectionModal() {
      this.isModalOpen = false; // Close the rejection modal
      this.message = ""; // Clear the rejection message
      this.rejectionId = null; // Reset the rejection ID
    },

    async submitRejection() {
      if (!this.message.trim()) {
        alert("Por favor, insira o motivo da rejeição.");
        return;
      }

      // Send the rejection request with the message
      await this.updatePullRequest(this.rejectionId, "R", this.message);

      // Close the modal and reset fields
      this.closeRejectionModal();
    },

    async updatePullRequest(id, action, message) {
      this.loading = true;
      this.error = null;

      try {
        if (action === "A") {
          message = "Aprovado";
        }
        console.log("Sending action to API:", { id, action, message });

        const response = await axios.post(
          `app/updateTeamPull/${id},${action},${message}`,
        );

        if (response.status === 200 && response.data.status_id) {
          alert(
            `Ação ${action === "A" ? "Aprovada" : "Rejeitada"} com sucesso!`,
          );
          await this.fetchTeam(); // Refresh the data after successful action
        } else {
          alert("Erro ao atualizar o pedido.");
          console.error("Unexpected response:", response);
        }
      } catch (error) {
        console.error("Erro ao enviar o pedido:", error);
        if (error.response) {
          console.error("Error response data:", error.response.data);
        }
        alert("Erro ao processar o pedido. Tente novamente.");
      } finally {
        this.loading = false; // Always reset loading
      }
    },

    fetchName() {
      this.loading = true;
      this.error = null;
      this.user = null;

      this.axios
        .get("app/getInfo")
        .then((response) => {
          // Assuming response.data contains the object with the name field
          this.user = response.data.name;
          this.ufs_code = response.data.ufs_code;
          this.loading = false;
        })
        .catch((error) => {
          this.error = error.message;
          this.loading = false;
        });
    },

    openModal(imageUrl) {
      this.currentImage = imageUrl;
      this.modalOpen = true;
    },
    closeModal() {
      this.modalOpen = false;
      this.currentImage = null;
    },
  },
};
</script>

<style>
.spinner {
  width: 80px;
  height: 80px;
  text-align: center;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  /* 50% opacity grey */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  /* Make sure it's on top of everything */
}

/* Estilos Gerais */
#user-table {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  color: #2c3e50;
  margin: 20px;
}

.card {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 20px;
  background-color: #f9f9f9;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.table th,
.table td {
  border: 1px solid #ddd;
  padding: 10px;
  text-align: center;
}

input[type="checkbox"] {
  transform: scale(1.2);
  cursor: pointer;
}

.btn-submit {
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

.btn-submit:hover {
  background-color: #0056b3;
}

.table th {
  background-color: #f48c4f;
  color: white;
  vertical-align: middle;
}

textarea.form-control {
  height: 200px;
}

/* Responsividade */
.table-responsive {
  overflow-x: auto;
}

.comprovativo-img {
  width: 50px;
  height: 50px;
  border-radius: 5px;
  align-items: center;
}

/* Botões */
.btn-accept,
.btn-reject {
  border: none;
  background: none;
  cursor: pointer;
  font-size: 16px;
  margin: 0 5px;
}

.btn-accept {
  color: #00c939;
}

.btn-reject {
  color: red;
}

.btn-accept:hover {
  color: #008f2c;
}

.btn-reject:hover {
  color: #cc0000;
}

/* Ajustes para telas pequenas */
@media (max-width: 768px) {
  .table th,
  .table td {
    font-size: 12px;
    padding: 5px;
    vertical-align: middle !important;
  }

  .comprovativo-img {
    width: 40px;
    height: 40px;
  }

  .btn-accept,
  .btn-reject {
    font-size: 14px;
  }
}

.format {
  background-color: none;
  border: none;
  color: #ff5a00;
}

@media (max-width: 480px) {
  h1 {
    font-size: 18px;
    text-align: center;
  }

  .card {
    padding: 10px;
  }

  .table th,
  .table td {
    font-size: 10px;
    padding: 3px;
    text-align-last: center;
    vertical-align: middle;
  }

  .comprovativo-img {
    width: 30px;
    height: 30px;
  }

  .btn-accept,
  .btn-reject {
    font-size: 12px;
  }
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  max-width: 90%;
  max-height: 90%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative;
}

.modal-content img {
  width: 100%;
  height: auto;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content .close {
  position: absolute;
  top: 10px;
  right: 15px;
  font-size: 24px;
  color: #333;
  cursor: pointer;
}

#form-contact .modal-body {
  padding: 0 0;
  padding-top: 20px;
}

#form-contact .border-box {
  border: 1px solid #e4e7ea;
  border-radius: 5px;
  padding: 10px;
  /*background-color: #f8f9fa;*/
  margin-bottom: 20px;
  font-size: 16px;
}

#form-contact .form-group {
  margin-bottom: 15px;
}

#form-contact .form-name {
  width: 100%;
  /* padding: 10px; */
  font-size: 14px;
  min-height: 5vh;
  max-height: 5vh;
}

.close:hover {
  color: black;
}

.main .container-fluid {
  padding: 50px 5px !important;
}

.btn-view-image {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

#download .btn-primary {
  background-color: #fff;
  color: #c26e00;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  width: 60%;
  margin-top: 30px;
  text-transform: uppercase;
  margin-left: 20%;
  margin-right: 20%;
  margin-bottom: 30px;
}

#form-contact .close-btn {
  color: #c26e00;
  border: none;
  /* display: flex; */
  justify-content: center;
  align-items: center;
  background: none;
  cursor: pointer;
}

.btn-view-image:hover {
  background-color: #0056b3;
}
</style>
